import * as fetchUnit from "./fetchUnit";
import { initialState as fetchUnitInitialState, FetchUnitInfoState } from "./fetchUnit";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...fetchUnit.Types
};

export const Actions: { fetchUnit: typeof fetchUnit.Actions} = {
    fetchUnit: fetchUnit.Actions
};

export const fetchUnitRequestReducer = reduceReducers<FetchUnitInfoState>(
    fetchUnitInitialState,
    fetchUnit.default as any
);

export default {
    fetchUnit: fetchUnitRequestReducer
};